<div class="auth">
  <div class="login-form">
    @if (oneTimeAccessFormGroup) {
      <form [formGroup]="oneTimeAccessFormGroup">
        <h3>{{ 'auth.enterCode' | translate }}</h3>
        @if (selectedMode === Mode.Email) {
          <div class="desc">
            {{ 'auth.codeEmailSent' | translate }}
            {{ userInfoFormGroup.get('userIdentifier').value }}
          </div>
        }
        @if (selectedMode === Mode.SMS) {
          <div class="desc">
            {{ 'auth.codeSmsSent' | translate }}
            {{ userInfoFormGroup.get('userIdentifier').value }}
          </div>
        }
        <div class="form-group">
          <dx-text-box
            valueChangeEvent="change keyup"
            [maxLength]="6"
            formControlName="accessCode"
            class="acenter">
          </dx-text-box>
          @if (displayRequiredError(oneTimeAccessFormGroup.get('accessCode'))) {
            <div class="ng-invalid-comment">
              {{ 'validation.required' | translate }}
            </div>
          }
          <div class="small-desc">
            {{ 'auth.codeIsCaseSensitive' | translate }}
          </div>
        </div>
        <div class="submit">
          <dx-button
            class="btn-xl btn-rounded"
            stylingMode="contained"
            type="default"
            text="{{ 'auth.verify' | translate }}"
            (onClick)="onOneTimeCodeSubmit()">
          </dx-button>
        </div>
      </form>
    }
  </div>
  @if (canReturn) {
    <div class="form-footer">
      <a
        href="javascript:void(0)"
        class="simple-btn simple-btn-sm simple-btn-rounded simple-btn-dark-line"
        (click)="onBack()">
        <i class="icon-left-arrow"></i>
        <span>{{ 'general.back' | translate }}</span>
      </a>
    </div>
  }
</div>
